var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArea05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V54C64 59.5228 59.5228 64 54 64H10C4.47715 64 0 59.5228 0 54V10Z",
    fill: "#C9A962",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44V33.3333C36 32.9797 35.8595 32.6406 35.6095 32.3905C35.3594 32.1405 35.0203 32 34.6667 32H29.3333C28.9797 32 28.6406 32.1405 28.3905 32.3905C28.1405 32.6406 28 32.9797 28 33.3333V44",
    stroke: "#C9A962",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.3333C19.9999 28.9454 20.0844 28.5622 20.2477 28.2103C20.411 27.8584 20.6491 27.5464 20.9453 27.296L30.2787 19.2973C30.76 18.8905 31.3698 18.6674 32 18.6674C32.6302 18.6674 33.24 18.8905 33.7213 19.2973L43.0547 27.296C43.3509 27.5464 43.589 27.8584 43.7523 28.2103C43.9156 28.5622 44.0001 28.9454 44 29.3333V41.3333C44 42.0406 43.719 42.7189 43.219 43.2189C42.7189 43.719 42.0406 44 41.3333 44H22.6667C21.9594 44 21.2811 43.719 20.781 43.2189C20.281 42.7189 20 42.0406 20 41.3333V29.3333Z",
    stroke: "#C9A962",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea05);
export default __webpack_public_path__ + "static/media/area05.b63c830ea632ff4dfaf6ff5e82ac42e6.svg";
export { ForwardRef as ReactComponent };